<!--
 * @Author: LiuMeiYu
 * @Date: 2022-07-23 10:44:31
 * @LastEditors: LiuMeiYu
 * @LastEditTime: 2022-07-23 12:00:29
 * @FilePath: \paceed\src\App.vue
 * @Description: *
 * *
 * Copyright (c) 2022 by yihua, All Rights Reserved.
-->
<template>
  <router-view />
</template>

<style>
html,
body {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
